document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.myVideo');
    let observer;

    // Intersection Observerの設定
    const options = {
        root: null, // viewportをルートとして設定
        rootMargin: '0px',
        threshold: 0.5  // 50%以上要素が表示された時にcallbackを発火
    };

    // 遅延ローディングの関数
    const loadVideo = (video) => {
        const sources = video.querySelectorAll('source');
        if (sources.length > 0) {
            sources.forEach(source => {
                source.src = source.dataset.src;
            });
        } else {
            video.src = video.dataset.src;
        }
        video.load();
    };
    // Observerのコールバック関数
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {  // 要素がビューポートに入った場合
                if ((video.querySelector('source') && video.querySelector('source').dataset.src && !video.querySelector('source').src) ||
                    (!video.querySelector('source') && video.dataset.src && !video.src)) {  // 動画がまだロードされていなければロードする
                    video.playWhenLoaded = true;
                    loadVideo(video);
                } else if (video.readyState >= 3) { // ビデオが少なくとも部分的にロードされている場合
                    video.play().catch(error => {
                        // ユーザーとのインタラクションがない状態での再生がブロックされた場合のエラーハンドリング
                        console.log('Auto-play was prevented: ' + error);
                    });  // 動画再生
                }
            } else {
                video.pause();  // 動画停止
            }
        });
    };

    // Observerのインスタンス化
    observer = new IntersectionObserver(observerCallback, options);

    // 各動画要素に対してobserverを適用
    videos.forEach(video => {
        video.addEventListener('loadeddata', function() {
            if (this.playWhenLoaded) {
                this.play().catch(error => {
                    // ユーザーとのインタラクションがない状態での再生がブロックされた場合のエラーハンドリング
                    console.log('Auto-play was prevented: ' + error);
                });
                this.playWhenLoaded = false;
            }
        });
        observer.observe(video);
    });

    const modal = document.querySelector('.c-modal');
    const playerWrapper = document.querySelector('.m-modal-ytPlayer');
    const closeBtn = document.querySelector('.m-modal-close');

    const movies = document.querySelectorAll('.m-movieList-item a');
    movies.forEach((item)=>{
        item.addEventListener('click',function(e){
            e.preventDefault();
            const movieID = e.currentTarget.dataset.movieid;
            const gtmLabel = e.currentTarget.dataset.gtmClick;
            openModal(movieID,gtmLabel);
        });
    })

    closeBtn.addEventListener('click',function(e){
        e.preventDefault();
        closeModal();
    });

    const openModal = (movieID,gtmLabel) => {
        modal.classList.add('-open');
        const player = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${movieID}?rel=0" title="YouTube video player"   frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
        playerWrapper.insertAdjacentHTML('beforeend',player);
        document.querySelector('.m-modal-close').dataset.gtmClick = `${gtmLabel}-close`;
    }
    const closeModal = () => {
        modal.classList.remove('-open');
        playerWrapper.querySelector('iframe').remove();
    }

});
